import { render, staticRenderFns } from "./CardNewSuperuser.vue?vue&type=template&id=51437838&"
import script from "./CardNewSuperuser.vue?vue&type=script&lang=js&"
export * from "./CardNewSuperuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports